"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var ugc_carousel_1 = require("../../utils/shopify-graphql/ugc-carousel");
var UgcCarouselMain_1 = require("./UgcCarouselMain");
var BeforeAfterCarouselMain_1 = require("./BeforeAfterCarouselMain");
var path_1 = require("../../utils/shopify/path");
var UgcCarousel = function (_a) {
    var isNewUGC = _a.isNewUGC;
    var _b = (0, hooks_1.useState)(null), ugcReviews = _b[0], setUgcReviews = _b[1];
    var _c = (0, hooks_1.useState)(''), color = _c[0], setColor = _c[1];
    var _d = (0, hooks_1.useState)(false), isBeforeAfter = _d[0], setBeforeAfter = _d[1];
    var _e = (0, hooks_1.useState)(''), reviewStars = _e[0], setReviewStars = _e[1];
    (0, hooks_1.useEffect)(function () {
        var handle = window.location.pathname.split('/')[2];
        // this will return 'collection', 'product', or 'page' based on url
        var pathType = (0, path_1.getPathType)(location);
        if (!pathType) {
            console.error('this module needs to be loaded within Collection or Page or Product url');
            return;
        }
        (0, ugc_carousel_1.getUgcCarouselData)(handle, pathType)
            .then(function (data) {
            if (data === null || data === void 0 ? void 0 : data.value) {
                var ugcData = JSON.parse(data.value);
                var ugcReviews_1 = ugcData.reviews;
                setBeforeAfter(ugcData.beforeAfter);
                if (ugcData.testReviews && window.sessionStorage.getItem('reviews-ab') === 'true') {
                    ugcReviews_1 = ugcData.testReviews;
                }
                setUgcReviews(ugcReviews_1);
                setColor(ugcData.theme);
                setReviewStars(ugcData.starsImg);
            }
        })
            .catch(function (err) { return console.error(err); });
    }, []);
    if (!ugcReviews && location.pathname == '/') {
        var newData = {
            reviews: [
                {
                    title: 'No more worries!',
                    backgroundImg: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/vp-ugc-review-image-1.jpg?v=1705522357',
                    author: 'KD S.',
                    body: "I have always been worried about my smell and taste, and  I'm prone to yeast infections & BV. These capsules have made me feel so much more confident and they work so fast!",
                },
                {
                    title: 'Night sweats GONE!!!',
                    backgroundImg: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/meno-ugc-carousel-1.jpg?height=842',
                    author: 'Ann',
                    body: "My night sweats are gone and I've lost 11 pounds of nasty hormone weight. It's worth it!!",
                },
                {
                    title: "I was skeptical, now I'm sold",
                    backgroundImg: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/flo-os-review-photo-4.jpg?v=1712254874',
                    author: 'Rebecca',
                    body: 'I went from having to shave hairs off my chin twice a day to only shaving once per evening. I will take it! I also got my period after being on these for two weeks.',
                },
                {
                    title: 'Happy!',
                    backgroundImg: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/vp-ugc-review-image-3.jpg?v=1705522382',
                    author: 'Jeni R.',
                    body: "I didn't even tell my guy I was taking something, he recognized the difference and asked me about it! And that was only the second bottle!!",
                },
                {
                    title: "it's working!!!",
                    backgroundImg: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/meno-ugc-carousel-4.jpg?height=842',
                    author: 'Sandy',
                    body: "I took these and 3 days in I had no hot flashes and slept better than I had in a long time. It's working for me. I'm on my third month and will never be without it.",
                },
                {
                    title: 'Keeping this routine',
                    backgroundImg: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/flo-os-review-photo-1.png?v=1712254875',
                    author: 'Violet',
                    body: 'I am on my second month and already seeing results, less unwanted chin hair and better skin in general.',
                },
                {
                    title: 'Best thing for your Period',
                    backgroundImg: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/image-review-4.jpg?v=1700076345',
                    author: 'Britt M.',
                    body: 'I have been taking FLO for a couple months and could not be happier. I have not had a major break-out, cramps are not as severe. If you are thinking about it, TRY IT!',
                },
            ],
            theme: 'gogo-orange',
        };
        setUgcReviews(newData.reviews);
        setColor(newData.theme);
    }
    if (ugcReviews && color) {
        return isBeforeAfter ? ((0, preact_1.h)(BeforeAfterCarouselMain_1.default, { stars: reviewStars, reviews: ugcReviews, color: color })) : ((0, preact_1.h)(UgcCarouselMain_1.default, { isNewUGC: isNewUGC, reviews: ugcReviews, color: color }));
    }
    else {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
};
exports.default = UgcCarousel;
